import { useTranslation } from 'react-i18next';

import { CheckSelect } from './FilterDropdown';

export { CheckSelect } from './FilterDropdown';

export interface StatusOption<Value extends string = string> {
  value: Value;
  /** Подпись уже переведённая — та же, что в колонке «Статус». */
  label: string;
  /** Цвет метки — тот же, что в колонке «Статус». */
  color?: string;
}

interface Props<Value extends string> {
  value: Value[];
  onChange: (value: Value[]) => void;
  options: Array<StatusOption<Value>>;
  width?: number;
}

/**
 * Фильтр по статусу над таблицей — с галочками, можно выбрать несколько.
 *
 * Статусы в списке — тем же цветом, что метки в колонке «Статус»: в списке
 * ищут глазами цвет, а не читают слово.
 */
export function StatusFilter<Value extends string = string>({
  value,
  onChange,
  options,
  width = 190,
}: Props<Value>) {
  const { t } = useTranslation();

  return (
    <CheckSelect<Value>
      value={value}
      onChange={onChange}
      width={width}
      placeholder={t('Статус')}
      options={options}
    />
  );
}

/** Значение фильтра для запроса: «A,B» или ничего, если не выбрано. */
export const listParam = (values: Array<string | number>): string | undefined =>
  values.length > 0 ? values.join(',') : undefined;

/**
 * «Работает / Уволен» (или «Активен / Отключён») — признак да/нет. Отмечено
 * одно — фильтр по нему; оба или ничего — без фильтра.
 */
export const activeParam = (values: string[], activeValue = 'active'): boolean | undefined =>
  values.length === 1 ? values[0] === activeValue : undefined;
